import {
  getDate, getRandomGuid, isPresent, getReferrerType, getSaveAndRetrieveParams, arrayContains,
} from './commonUtils';
import {
  EVENT_CONV_STEP_ARR, EVENT_JOUR_ARR, EVENT_ELE_ARR,
  RET_KEYS, INTERNAL_DOMAINS, EVENT_ELE_START, EVENT_ELE_SUBMIT, EU_MARKET_LIST,
} from './constants';
import { makeRequest } from './makeRequest';
import { getVisitorId, getCookie } from './cookieUtils';

export const campaignData = {
  gctVstrId: '',
  axp: false,
  isLandDedup: false,
  isRunning: false,
  domainName: '',
  mktCd: '',
  icatsImg: '',
  fullURL: '',
  RefURL: '',
  vid: '',
  entryPoint: '',
  entryPointOld: '',
  env: process.env.AEXP_ENV,
  rsid: 'amexpressdev',
  envUrl: process.env.GLOBAL_CAMPAIGN_FAAS_URL,
  market: '',
  zipCode: '',
  pageName: '',
  element: '',
  applyFlow: '',
  pcn: '',
  eep: '',
  appConfig: '',
  journey: '',
  conversionStep: '',
  suppAdded: '',
  appDecision: '',
  lob: '',
  pmc: '',
  width: 0,
  height: 0,
  eventNo: '',
  eMGMChannel: '',
  productCode: '',
  rwdexp: '',
  isUSSuppPage: false,
  campaignData: '',
  locale: '',
  isConsentCookieExists: false,
  euDigitalData: '',
};

export const resetVars = () => {
  campaignData.mktCd = '';
  campaignData.entryPoint = '';
  campaignData.entryPointOld = '';
  campaignData.market = '';
  campaignData.zipCode = '';
  campaignData.pageName = '';
  campaignData.element = '';
  campaignData.applyFlow = '';
  campaignData.pcn = '';
  campaignData.eep = '';
  campaignData.appConfig = '';
  campaignData.journey = '';
  campaignData.conversionStep = '';
  campaignData.suppAdded = '';
  campaignData.appDecision = '';
  campaignData.lob = '';
  campaignData.pmc = '';
  campaignData.width = 0;
  campaignData.height = 0;
  campaignData.eventNo = '';
  campaignData.eMGMChannel = '';
  campaignData.productCode = '';
  campaignData.rwdexp = '';
  campaignData.isUSSuppPage = false;
  campaignData.gctParams = '';
};

export const setRwdExp = () => {
  let orientation = '';
  if (campaignData.height > 0 && campaignData.width > 0) {
    if (campaignData.height > campaignData.width) {
      orientation = 'portrait';
    } else if (campaignData.height < campaignData.width) {
      orientation = 'landscape';
    }
    if (campaignData.width > 0 && isPresent(orientation)) {
      campaignData.rwd_exp = `${campaignData.width}px|${orientation}`;
    }
  }
};

export const processEvent = event => isPresent(event.meta.journey)
    && (EVENT_JOUR_ARR.includes(event.meta.journey.toLowerCase()))
    && ((isPresent(event.element) && (EVENT_ELE_ARR.includes(event.element.toLowerCase()))
    ) || (isPresent(event.meta.conversionStep)
      && (EVENT_CONV_STEP_ARR.includes(event.meta.conversionStep.toLowerCase()))));


export const isGCTEvent = (gctDigitalDataParams) => {
  let isServerCallAllowed = false;
  if (isPresent(gctDigitalDataParams)) {
    if (isPresent(gctDigitalDataParams.diff) && (gctDigitalDataParams.diff).includes('view')) {
      isServerCallAllowed = true;
    } else if (isPresent(gctDigitalDataParams.diff) && (gctDigitalDataParams.diff).includes('events')) {
      gctDigitalDataParams.events.forEach((event) => {
        if (isPresent(event.meta)) {
          isServerCallAllowed = processEvent(event);
        }
      });
    }
  }
  return isServerCallAllowed;
};

export const getMarketCode = (gctDigitalDataParams) => {
  let marketCode = '';
  if (isPresent(gctDigitalDataParams.view) && isPresent(gctDigitalDataParams.view.country)) {
    marketCode = gctDigitalDataParams.view.country;
    marketCode = marketCode.toLowerCase();
  }
  return marketCode;
};

export const getPageName = (gctDigitalDataParams) => {
  let pageName = '';
  if (isPresent(gctDigitalDataParams.events) && gctDigitalDataParams.events.length > 0) {
    gctDigitalDataParams.events.forEach((event) => {
      if (isPresent(event.element)) {
        pageName = event.element;
        pageName = pageName.toLowerCase();
      }
    });
  }
  return pageName;
};

export const getProductCode = () => {
  if (isPresent(campaignData.market) && isPresent(campaignData.lob) && isPresent(campaignData.pmc)) { campaignData.productCode = `${campaignData.market}:${campaignData.lob}:${campaignData.pmc}`; }
};

export const domesticApiCall = (marketCode, gctDigitalDataParams) => {
  let domesticUrl = '';
  let params = '';
  getProductCode();
  const fullURL = decodeURIComponent(document.URL);
  const referrerURL = isPresent(window.document) ? window.document.referrer : '';
  const referrerType = getReferrerType(referrerURL, INTERNAL_DOMAINS);
  domesticUrl = `${campaignData.envUrl}captureevents.do`;
  campaignData.gctParams = campaignData.gctParams.concat('gctracus=', `${getVisitorId(marketCode)}`);
  campaignData.gctParams = campaignData.gctParams.concat('&entryPoint=', `${campaignData.entryPoint}`);
  campaignData.gctParams = campaignData.gctParams.concat('&fullurl=', `${encodeURIComponent(fullURL)}`);
  campaignData.gctParams = campaignData.gctParams.concat('&RefURL=', `${encodeURIComponent(referrerURL)}`);
  campaignData.gctParams = campaignData.gctParams.concat('&reftype=', `${referrerType}`);
  campaignData.gctParams = campaignData.gctParams.concat('&isOneAmex=', 'true');
  campaignData.gctParams = campaignData.gctParams.concat('&digitalDataJSON=', `${encodeURIComponent(JSON.stringify(gctDigitalDataParams))}`);
  params = campaignData.gctParams;
  makeRequest(domesticUrl, params);
};

export const getAppDecision = (eventnum, appdecision) => {
  let decisionevent = '';
  if (eventnum === 'event5') {
    if (appdecision.toLowerCase() === 'approved') { decisionevent = ',event10'; }
    if (appdecision.toLowerCase() === 'declined') { decisionevent = ',event11'; }
    if (appdecision.toLowerCase() === 'cancelled') { decisionevent = ',event67'; }
    if (appdecision.toLowerCase() === 'pended') { decisionevent = ',event9'; }
  } else if (eventnum === 'event24') {
    if (appdecision.toLowerCase() === 'approved') { decisionevent = ',event35'; }
    if (appdecision.toLowerCase() === 'declined') { decisionevent = ',event36'; }
    if (appdecision.toLowerCase() === 'cancelled') { decisionevent = ',event37'; }
  }
  return decisionevent;
};

/* eslint-disable complexity */
export const getEventNumber = () => {
  let decision = '';
  const {
    journey, conversionStep, suppAdded, appDecision,
  } = campaignData;
  const element = campaignData.pageName;
  if (!isPresent(campaignData.eventNo) && isPresent(journey)) {
    if (journey.toLowerCase() === 'cardapplication') {
      if (isPresent(element) && (EVENT_ELE_SUBMIT.includes(element.toLowerCase()))) {
        if (!isPresent(conversionStep)
          || (isPresent(conversionStep) && !conversionStep.toLowerCase().includes('suppapplicationcomplete'))) {
          campaignData.eventNo = campaignData.eventNo.concat('event5');
          if (isPresent(appDecision)) {
            decision = getAppDecision(campaignData.eventNo, appDecision);
            campaignData.eventNo = campaignData.eventNo.concat(decision);
          }
          if (isPresent(suppAdded) && suppAdded) { campaignData.eventNo = campaignData.eventNo.concat(',event3'); }
        }
      }
      if (isPresent(element) && (EVENT_ELE_START.includes(element.toLowerCase()))) { campaignData.eventNo = campaignData.eventNo.concat('event1:'); }
      if (!isPresent(campaignData.eventNo) && isPresent(conversionStep)) {
        if (conversionStep.toLowerCase().includes('suppapplicationcomplete')) {
          campaignData.eventNo = campaignData.eventNo.concat('event24');
          campaignData.isUSSuppPage = true;
        } else if (conversionStep.toLowerCase().includes('applicationsubmit')) {
          campaignData.eventNo = campaignData.eventNo.concat('event5');
          if (isPresent(suppAdded) && suppAdded) { campaignData.eventNo = campaignData.eventNo.concat(',event3'); }
        }
        if (isPresent(campaignData.eventNo) && (campaignData.eventNo === 'event5' || campaignData.eventNo === 'event24')) {
          if (isPresent(appDecision)) {
            decision = getAppDecision(campaignData.eventNo, appDecision);
            campaignData.eventNo = campaignData.eventNo.concat(decision);
          }
        }
        if (conversionStep.toLowerCase().includes('suppapplicationstart')) {
          campaignData.eventNo = campaignData.eventNo.concat('event47:');
          campaignData.isUSSuppPage = true;
        } else if (conversionStep.toLowerCase().includes('applicationstart')) {
          campaignData.eventNo = campaignData.eventNo.concat('event1:');
        }
      }
    } else if (journey.toLowerCase() === 'cardupgrade' && isPresent(conversionStep)) {
      if (conversionStep.toLowerCase().includes('upgradestart')) { campaignData.eventNo = campaignData.eventNo.concat('event82'); }
      if (conversionStep.toLowerCase().includes('upgradecomplete')) {
        campaignData.eventNo = campaignData.eventNo.concat('event84');
        if (isPresent(appDecision)) {
          if (appDecision.toLowerCase().includes('approve')) { campaignData.eventNo = campaignData.eventNo.concat(',event85'); }
          if (appDecision.toLowerCase().includes('decline')) { campaignData.eventNo = campaignData.eventNo.concat(',event86'); }
          if (appDecision.toLowerCase() === 'pended') { campaignData.eventNo = campaignData.eventNo.concat(',event87'); }
        }
      }
    }
  }
};

/* eslint-disable complexity */
export const parseDigitalData = (digitalData) => {
  if (!isPresent(digitalData)) {
    return;
  }
  if (isPresent(digitalData.view) && isPresent(digitalData.view.country)) {
    campaignData.market = digitalData.view.country;
    if (campaignData.market === 'GB') { campaignData.market = 'UK'; }
  }
  if (isPresent(digitalData.user) && isPresent(digitalData.user.postalCode)) {
    campaignData.zipCode = digitalData.user.postalCode;
  }
  if (isPresent(digitalData.device)) {
    if (isPresent(digitalData.device.width) && isPresent(digitalData.device.width.px)) {
      campaignData.width = digitalData.device.width.px;
    }
    if (isPresent(digitalData.device.height) && isPresent(digitalData.device.height.px)) {
      campaignData.height = digitalData.device.height.px;
    }
  }
  if (isPresent(digitalData.events)) {
    for (let i = 0; i < digitalData.events.length; i += 1) {
      if (isPresent(digitalData.events[i].element)) {
        campaignData.pageName = digitalData.events[i].element;
      }
      if (isPresent(digitalData.events[i].detail)) {
        campaignData.eMGMChannel = digitalData.events[i].detail;
      }
      if (isPresent(digitalData.events[i].meta)) {
        if (isPresent(digitalData.events[i].meta.applyflowID)) {
          campaignData.applyFlow = digitalData.events[i].meta.applyflowID;
        }
        if (isPresent(digitalData.events[i].meta.pcn)) {
          campaignData.pcn = digitalData.events[i].meta.pcn;
        }
        if (isPresent(digitalData.events[i].meta.eep)) {
          campaignData.eep = digitalData.events[i].meta.eep;
        }
        if (isPresent(digitalData.events[i].meta.appconfig)) {
          campaignData.appConfig = digitalData.events[i].meta.appconfig;
        }
        if (isPresent(digitalData.events[i].meta.journey)) {
          campaignData.journey = digitalData.events[i].meta.journey;
        }
        if (isPresent(digitalData.events[i].meta.conversionStep)) {
          campaignData.conversionStep = digitalData.events[i].meta.conversionStep;
        }
        if (isPresent(digitalData.events[i].meta.suppadded)) {
          campaignData.suppAdded = digitalData.events[i].meta.suppadded;
        }
        if (isPresent(digitalData.events[i].meta.appdecision)) {
          campaignData.appDecision = digitalData.events[i].meta.appdecision;
        }
        if (isPresent(digitalData.events[i].meta.products)) {
          for (let j = 0; j < digitalData.events[i].meta.products.length; j += 1) {
            if (isPresent(digitalData.events[i].meta.products[j].lineOfBusiness)) {
              campaignData.lob = digitalData.events[i].meta.products[j].lineOfBusiness;
            }
            if (isPresent(digitalData.events[i].meta.products[j].id)) {
              campaignData.pmc = digitalData.events[i].meta.products[j].id;
            }
          }
        }
        getEventNumber();
      }
    }
  }
};

/* eslint-disable complexity */
export const intlApiCall = (rsid, gctDigitalDataParams) => {
  let url = '';
  let params = '';
  try {
    getProductCode();
    const fullURL = decodeURIComponent(document.URL);
    const referrerURL = isPresent(window.document) ? window.document.referrer : '';
    const referrerType = getReferrerType(referrerURL, INTERNAL_DOMAINS);
    if (!isPresent(campaignData.gctVstrId)) { campaignData.gctVstrId = getVisitorId(); }
    if (!isPresent(campaignData.gctVstrId)) {
      campaignData.gctVstrId = getDate() + getRandomGuid();
    }
    campaignData.gctVstrId = campaignData.gctVstrId.replace('gctvid=', '');
    campaignData.gctVstrId = campaignData.gctVstrId.replace('"', '');
    url = `${campaignData.envUrl}captureIntl.do`;
    campaignData.gctParams = campaignData.gctParams.concat('&oneAmex=', 'AXPSupplierScript');
    /* istanbul ignore else */
    if (isPresent(`${referrerType}`))campaignData.gctParams = campaignData.gctParams.concat('&reftype=', `${referrerType}`);
    if (isPresent(campaignData.market))campaignData.gctParams = campaignData.gctParams.concat('&mkt=', campaignData.market);
    if (isPresent(campaignData.productCode))campaignData.gctParams = campaignData.gctParams.concat('&prodCode=', campaignData.productCode);
    if (isPresent(campaignData.applyFlow))campaignData.gctParams = campaignData.gctParams.concat('&appflow=', campaignData.applyFlow);
    if (isPresent(campaignData.pmc))campaignData.gctParams = campaignData.gctParams.concat('&pmc=', campaignData.pmc);
    if (isPresent(campaignData.pcn))campaignData.gctParams = campaignData.gctParams.concat('&epcn=', campaignData.pcn);
    if (isPresent(campaignData.appConfig))campaignData.gctParams = campaignData.gctParams.concat('&appconfig=', campaignData.appConfig);
    if (isPresent(campaignData.zipCode)) {
      campaignData.gctParams = campaignData.gctParams.concat('&zip=', campaignData.zipCode);
    }
    if (isPresent(campaignData.eventNo))campaignData.gctParams = campaignData.gctParams.concat('&event=', campaignData.eventNo);
    if (isPresent(campaignData.pageName))campaignData.gctParams = campaignData.gctParams.concat('&pageName=', campaignData.pageName);
    campaignData.gctParams = campaignData.gctParams.concat('&fullURL=', `${encodeURIComponent(fullURL)}`);
    if (isPresent(campaignData.eep))campaignData.gctParams = campaignData.gctParams.concat('&eep=', campaignData.eep);
    campaignData.gctParams = campaignData.gctParams.concat('&refURL=', `${encodeURIComponent(referrerURL)}`);
    if (isPresent(campaignData.rwd_exp))campaignData.gctParams = campaignData.gctParams.concat('&rwdexp=', campaignData.rwd_exp);
    if (isPresent(rsid))campaignData.gctParams = campaignData.gctParams.concat('&rsid=', `${encodeURIComponent(rsid)}`);
    campaignData.gctParams = campaignData.gctParams.concat('&gctvid=', campaignData.gctVstrId);
    if (typeof (window.gctvid) !== 'undefined' && window.gctvid !== null && window.gctvid !== '') {
      const snrParams = getSaveAndRetrieveParams(RET_KEYS);
      snrParams.forEach((key, value) => {
        campaignData.gctParams = campaignData.gctParams.concat('&', key, '=', value);
      });
    }
    if (campaignData.isEUConsentGiven) {
      campaignData.gctParams += `&isEUConsentGiven=${campaignData.isEUConsentGiven}`;
      campaignData.gctParams += `&euConsentVal=${campaignData.euConsentVal}`;
      campaignData.isEUConsentGiven = false;
    }
    if (campaignData.isLandDedup
        && (isPresent(campaignData.RefURL) || fullURL.includes('cpid') > 0
        || fullURL.includes('CPID') > 0)) {
      campaignData.gctParams = campaignData.gctParams.concat('&isLandDedup=isLandDedup');
    }
    campaignData.gctParams = campaignData.gctParams.concat('&digitalDataJSON=', `${encodeURIComponent(JSON.stringify(gctDigitalDataParams))}`);
    params = campaignData.gctParams;
    makeRequest(url, params);

    /* Not able to test if */
    /* istanbul ignore if */
    if ((isPresent(campaignData.RefURL) || fullURL.includes('cpid') > 0
      || fullURL.includes('CPID') > 0)) {
      campaignData.isLandDedup = true;
    }
  } catch (err) {
    /* istanbul ignore next */ console.log(`Inside intlApiCall : ${err}`);
  }
};

/* eslint-disable complexity */
export const gctTrackingHandler = (gctDigitalDataParams) => {
  let status = false;
  resetVars();
  parseDigitalData(gctDigitalDataParams);
  /* istanbul ignore next */ campaignData.rsid = (campaignData.env === 'E3') ? 'amexpressprod' : 'amexpressdev';
  setRwdExp();
  const isGCTSupportedEvent = isGCTEvent(gctDigitalDataParams);
  if (isPresent(gctDigitalDataParams) && isPresent(gctDigitalDataParams.diff)
    && gctDigitalDataParams.diff.length > 0) {
    const marketCode = getMarketCode(gctDigitalDataParams);
    const pageName = getPageName(gctDigitalDataParams);
    /* istanbul ignore else */
    if (marketCode.toLowerCase() === 'us') {
      if (gctDigitalDataParams.diff.includes('view')
        || (isPresent(campaignData.entryPoint)
          || campaignData.entryPointOld !== campaignData.entryPoint)
        || (gctDigitalDataParams.diff.includes('events') && campaignData.isUSSuppPage)) {
        domesticApiCall(marketCode, gctDigitalDataParams);
      }
    } else if (marketCode.toLowerCase() !== 'us' && (isGCTSupportedEvent || (typeof (pageName) !== 'undefined'
      && (pageName.toLowerCase() === 'MGMHubPage'.toLowerCase() || pageName.toLowerCase() === 'MGMThankyou'.toLowerCase())))) {
      try {
        intlApiCall(campaignData.rsid, gctDigitalDataParams);
      } catch (err) { /* istanbul ignore next */ console.log(`Exception in intlApiCall: ${err}`); }
    }
    status = true;
  }
  return status;
};

export const triggerGCTEUCall = (euResponse) => {
  if (euResponse === 'true' || (typeof euResponse === 'string' && euResponse.indexOf('A:Y') >= 0)) {
    campaignData.isEUCookieConsentGiven = true;
    campaignData.isCallTriggered = true;
    if (typeof (campaignData.euDigitalData) !== 'undefined') {
      campaignData.isEUConsentGiven = true;
      campaignData.euConsentVal = euResponse;
      gctTrackingHandler(campaignData.euDigitalData);
    }
  } else {
    campaignData.isEUCookieConsentGiven = false;
  }
};


export const initializeEUCall = (gctDigitalData) => {
  /* Get Market and Locale from digitalData */
  if (isPresent(gctDigitalData.view) && isPresent(gctDigitalData.view.country)) {
    /* mkt_cd */
    campaignData.mktCd = gctDigitalData.view.country;
    /* Locale */
    if (isPresent(gctDigitalData.view.language)) campaignData.locale = `${gctDigitalData.view.country}_${gctDigitalData.view.language}`;
  }
  /* EU Cookie Check - START */
  if (arrayContains(EU_MARKET_LIST, campaignData.mktCd) && !campaignData.isConsentCookieExists) {
    let gctEUCkConsentVal = getCookie('CookieConsent');
    if (gctEUCkConsentVal !== '') {
      if (gctEUCkConsentVal.indexOf(campaignData.locale) >= 0) {
        gctEUCkConsentVal = gctEUCkConsentVal.substring(
          gctEUCkConsentVal.indexOf(campaignData.locale),
          gctEUCkConsentVal.indexOf(campaignData.locale) + 21);
        campaignData.isConsentCookieExists = gctEUCkConsentVal.indexOf('A:Y') >= 0;
      } else campaignData.isConsentCookieExists = false;
    } else campaignData.isConsentCookieExists = false;

    if (isPresent(gctDigitalData.diff)
      && (arrayContains(gctDigitalData.diff, 'view')
      || (arrayContains(gctDigitalData.diff, 'events')
          && (campaignData.eventNo.indexOf('event1') >= 0
            || campaignData.eventNo.indexOf('event47') >= 0
            || campaignData.eventNo.indexOf('event24') >= 0
            || campaignData.eventNo.indexOf('event5') >= 0
            || campaignData.eventNo.indexOf('event82') >= 0
            || campaignData.eventNo.indexOf('event84') >= 0
            || (typeof (campaignData.pageName) !== 'undefined'
              && campaignData.pageName.indexOf('MGM') >= 0))))) {
      campaignData.euDigitalData = gctDigitalData;
    }

    if (!campaignData.isConsentCookieExists) {
      if (typeof (window.EuCookieConsentHandlers) !== 'undefined') {
        if (window.EuCookieConsentHandlers.indexOf(triggerGCTEUCall) < 0) {
          window.EuCookieConsentHandlers.push(triggerGCTEUCall);
        }
      } else window.EuCookieConsentHandlers = [triggerGCTEUCall];
    }
  }
  /* EU Cookie Check - END */
};

export const gctHandler = (gctDigitalData) => {
  if (isPresent(gctDigitalData)) {
    // eslint-disable-next-line no-param-reassign
    gctDigitalData = JSON.parse(JSON.stringify(gctDigitalData));
    // gctTrackingHandler(JSON.parse(JSON.stringify(gctDigitalData)));
    gctTrackingHandler(gctDigitalData);
    initializeEUCall(gctDigitalData);
  }
};

export const processGlobalEvents = () => {
  if (typeof (window.DataManager) !== 'undefined') {
    /* istanbul ignore next */
    window.DataManager.subscribe({ subscriber: 'gct', handler: (data) => { gctHandler(data); } });
  } else if (typeof (window.digitalDataHandlers) !== 'undefined' && window.digitalDataHandlers.indexOf(gctHandler) === -1) {
    window.digitalDataHandlers.push(gctHandler);
  }
};
